import React from 'react'

type FormOptionProp = {
    title: string
    value: string
    onChange: () => void
    options: { label: string; value: string }[]
}

export default function FormOption({
    title,
    value,
    onChange,
    options,
}: FormOptionProp) {
    const selected = options.find((o) => o.value === value)?.label || ''
    return (
        <div className="form-option">
            <div className="dropdown">
                <span
                    id={`lbl-${title}`}
                    className="ddl-label"
                    style={{
                        fontSize: '0.8rem',
                    }}
                >
                    {title}: {selected}
                </span>
                <div className="dropdown-arrow">▾</div>

                <select value={value} onChange={onChange}>
                    {options.map((o) => (
                        <option key={o.value} value={o.value}>
                            {o.label}
                        </option>
                    ))}
                </select>
            </div>
        </div>
    )
}
